module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "empty-state-wrapper"
  }, [_c('img', {
    attrs: {
      "src": _vm.imageSrc
    }
  }), _vm._v(" "), (_vm.heading) ? _c('h3', [_vm._v(_vm._s(_vm.heading))]) : _vm._e(), _vm._v(" "), (_vm.subtitle) ? _c('p', [_vm._v(_vm._s(_vm.subtitle))]) : _vm._e(), _vm._v(" "), (_vm.button) ? _c('add-button', {
    staticClass: "buttons"
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6caa521c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/helpers/DataDisplay/EmptyStateContacts.vue
// module id = 1935
// module chunks = 0